import axios from 'axios'
import { ActionTree } from 'vuex'

import { translationsUrl } from '@/data/appConfig'

import { Mutations, RootState, SupportedLanguages } from './types'

const languageFilePaths = {
  en: `${translationsUrl}/Website_English_US.json`,
  de: `${translationsUrl}/Website_German.json`,
}

const actions: ActionTree<RootState, RootState> = {
  async initLanguage({ dispatch, getters }) {
    const { chosenLanguage } = getters
    await dispatch('fetchLanguage', chosenLanguage)
  },

  async switchLanguage(
    { commit, dispatch },
    chosenLanguage: SupportedLanguages,
  ) {
    commit(Mutations.SWITCH_LANGUAGE, chosenLanguage)
    await dispatch('fetchLanguage', chosenLanguage)
  },

  translations({ commit }, value: Object) {
    commit(Mutations.SET_TRANSLATIONS, value)
  },

  async fetchLanguage({ dispatch }, chosenLanguage) {
    try {
      const response = await axios.get(languageFilePaths[chosenLanguage])
      dispatch('translations', response.data)

      return response.data
    } catch (error) {
      throw new Error(error)
    }
  },
}

export default actions
